export { FieldsetRoot as Root } from './root/FieldsetRoot.js';
export { FieldsetLegend as Legend } from './legend/FieldsetLegend.js';